module.exports = __webpack_public_path__ + "media/images/zEvent-Logo_Black-388e3c1e402797ec553cd612454ee555.png";